/**
 * Created by saeed on 1/3/2017.
 */
export class ServiceItemVM {
  id:number;
  itemTitle:string;
  description:string;
  minPreReserveTime:number;
  maxPreReserveTime:number;
  hasWaitingList:boolean;
  mustGetParticipantInfo:boolean;
  canBeCanceled:boolean;
  minPreCancelTime:number;
  paymentType;
  serviceType;
  categoryId:number;
  discountPrice:number;
  minPrice:number;
  maxDiscount:number;
  fullDescription:string;
  customSetting;
  meetingType: any;
  orderNo:number ;
  minConsecutivePeriod:number;
  maxConsecutivePeriod:number;
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/models/ServiceItemVM.ts